import { useTrans } from '../../../hooks'
import { ScrollRef, WContainer } from '../../atoms'
import { CardCollezioneList, Formats } from '../../molecules'
import styles from './FormatsColors.module.sass'

interface Props {
  refId?: string
  collezione: any // CollezioneNode[]
  className?: string
}

const FormatsColors = (props: Props) => {
  const { refId = undefined, collezione = undefined, className = '' } = props

  const t = useTrans()

  return collezione?.spessoriFormati?.length || collezione?.colori?.length ? (
    <div className={`${styles.root} ${className}`}>
      {refId && <ScrollRef id={refId} className={styles.ref} />}
      <WContainer className={styles.container}>
        <h2 className={styles.title}>{t('Formati e colori')}</h2>
        <Formats spessoriFormati={collezione.spessoriFormati} className={styles.formats} />
        <CardCollezioneList items={collezione.colori} className={styles.colors} />
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default FormatsColors
